import type { Guide } from './types.js';

/**
 * Generates and saves the Word copy of a guide. The Word writer is imported only when
 * somebody asks for the file, so it stays out of the bundle every other page pays for.
 */
export async function downloadGuideDocx(guide: Guide, fileName: string): Promise<void> {
  const { buildGuideDocxBlob } = await import('./docx.js');
  const url = URL.createObjectURL(await buildGuideDocxBlob(guide));
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
}
